export default "__VITE_ASSET__8abef657__"